// Plan Type值
export const PlanTypeGroup = [
  {
    label: 'Popular',
    value: 'Popular',
  },
  {
    label: 'Newly Introduced',
    value: 'NewlyIntroduced',
  },
  {
    label: 'Others',
    value: 'Others',
  },
];

export const PLAN_DEFAULT_PAGE_SIZE = 7; // 每页展示数量
